import { useState, useEffect, useRef } from 'react';
import './index.css';

const SLIDES = [
    { src: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/images/big1.webp', alt: 'xiaomai spreader' },
    { src: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/images/big2.webp', alt: 'xiaomai factory' },
    { src: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/images/big3.webp', alt: 'xiaomai machine' },
];
const INTERVAL = 5000;

export default function HeroSlider() {
    const [active, setActive] = useState(0);
    const [progress, setProgress] = useState(0);
    const [hidden, setHidden] = useState(false);
    const sliderRef = useRef(null);
    const timerRef = useRef(null);
    const startRef = useRef(null);

    const goTo = (idx) => {
        setActive(idx);
        setProgress(0);
        startRef.current = Date.now();
    };

    
    useEffect(() => {
        const tick = () => {
            const elapsed = Date.now() - startRef.current;
            const pct = Math.min((elapsed / INTERVAL) * 100, 100);
            setProgress(pct);
            if (pct >= 100) {
                setActive((prev) => (prev + 1) % SLIDES.length);
                startRef.current = Date.now();
            }
        };
        startRef.current = Date.now();
        timerRef.current = setInterval(tick, 50);

        const onScroll = () => {
            if (window.scrollY > 50) {
                setHidden(true);
            }
        };
        window.addEventListener('scroll', onScroll, { passive: true });

        return () => {
            clearInterval(timerRef.current);
            window.removeEventListener('scroll', onScroll);
        };
    }, []);

    return (
        <>
            <div ref={sliderRef} className={`hero-slider ${hidden ? 'hidden' : ''}`}>
                <div className="hero-top-line" />

                {SLIDES.map((slide, i) => (
                    <div key={i} className={`hero-slide ${i === active ? 'active' : ''}`}>
                        <img className="hero-slide-img" src={slide.src} alt={slide.alt} />
                    </div>
                ))}

                <div className="hero-gradient" />

                <div className="hero-brand">
                    <div className="hero-brand-cn">小麦科技</div>
                    <div className="hero-brand-en">XIAOMAI TECHNOLOGY</div>
                    <div className="hero-brand-divider" />
                </div>

                <div className="hero-contact">
                    <div className="hero-contact-label">全国服务热线</div>
                    <div className="hero-contact-phone">400-050-1183</div>
                </div>

                <div className="hero-dots">
                    {SLIDES.map((_, i) => (
                        <div
                            key={i}
                            className={`hero-dot ${i === active ? 'active' : ''}`}
                            onClick={() => goTo(i)}
                        />
                    ))}
                </div>

                <div className="hero-progress" style={{ width: `${progress}%` }} />
            </div>
        </>
    );
}
